<z-embedded-ui-overlay
  [overlay]="overlay"
  [url]="url()"
  [loading]="loading()"
  [loadingText]="'Resolving VictoriaLogs URL…'"
  [emptyText]="'VictoriaLogs is not available for this project.'"
  [newTabTitle]="'Open VictoriaLogs UI in new tab'"
  [trayId]="key"
  [trayCaption]="'VictoriaLogs'"
  [trayTitle]="projectName() || 'project logs'"
  [reloadTitle]="'Reload VictoriaLogs UI'"
  (reload)="onReload$.next()"
  (openInNewTab)="openInNewTab()"
  (closed)="onClose$.next()"
/>
